'use strict';

import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { Gradient } from './vendor/gradient.js'
import { on, throttle } from './modules/_fn';

gsap.registerPlugin(ScrollToPlugin)
/* ---------------------------------------- [START] IE Global Setting */
// 舊IE提醒
const userAgent = window.navigator.userAgent;
if (
	userAgent.indexOf('MSIE 7.0') > 0 ||
	userAgent.indexOf('MSIE 8.0') > 0 ||
	userAgent.indexOf('MSIE 9.0') > 0 ||
	userAgent.indexOf('MSIE 10.0') > 0 ||
	!!userAgent.match(/Trident.*rv\:11\./) // IE11
) {
	location.href = '/browser.html';
}
/* ---------------------------------------- [END] IE Global Setting */

/* ---------------------------------------- [START] Document Ready */
(function (window, document) {
	const usePageLoaded = async () => {
		document.body.classList.add('page--loaded')
		await new Promise(resolve => setTimeout(resolve, 1000))
	}

	document.addEventListener('DOMContentLoaded', async () => {
		await usePageLoaded()
		scrollTriggerAni()
		on(window, 'scroll', scrollTriggerAniThrottle)
	})


	/* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	on(window, 'load', getWinSet);
	on(window, 'resize', throttle(getWinSet, 50, 100));
	/* ---------------------------------------- [END] Windows Setting */

	/* ---------------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	let isMobile = false;
	let isTablet = false;
	let isPhone = false;

	const deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if(isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};

	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ---------------------------------------- [END] 取得裝置判斷 */

	/* ---------------------------------------- [START] 判斷browser */
	var ua = navigator.userAgent;
	var browser = {
		isChrome: /chrome/i.test(ua),
		isFirefox: /firefox/i.test(ua),
		isSafari: /safari/i.test(ua),
		isIE: /msie/i.test(ua) || /trident/i.test(ua),
		isEdge: /edge/i.test(ua),
	};

	// 修正數值browser
	if (browser.isChrome) browser.isSafari = false;
	if (browser.isEdge) {
		browser.isChrome = false;
		browser.isSafari = false;
	}

	var browserIs;
	for (var key in browser) {
		if (browser[key]) {
			browserIs = key.split('is')[1];
			// 增加Class
			document.documentElement.classList.add(browserIs.toLowerCase());
			document.documentElement.browser = browserIs;
			break;
		}
	}
	browser.is = browserIs;

	// ----------------------------
	// 判斷 裝置
	// iOS
	var isiOS = ua.toLowerCase().match(/(iphone|ipod|ipad)/);
	isiOS && html.classList.add('ios');
	/* ---------------------------------------- [END] 判斷browser */

	/* ----------------------------------- [START] Loader 移除 */
	var loaderRemove = function () {
		var loader = document.querySelector('#loader');
		window.loader = loader; // 加到 window 上

		pageLoaded();
	};
	// on(window, 'load', loaderRemove);

	/* 頁面可呼叫的 function -------- */
	/* 開啟 Loading */
	window.pageLoading = function() {
		loader.classList.remove('loaded');
		document.body.appendChild(loader);
	}

	/* 關閉 Loading */
	window.pageLoaded = function() {
		loader.classList.add('loaded');
		setTimeout(function () {
			loader.remove();
		}, 2500);
	}
	/* ----------------------------------- [END] Loader 移除 */

	/* ---------------------------------------- [START] LazyLoad */
	/*
	 * 使用：https://github.com/verlok/vanilla-lazyload
	 * 尋找頁面上的 .lazy 為執行 Lazy Load 物件
	 */
	var lazyloadTimer = 0;
	function buildLazyLoad() {
		if (lazyloadTimer < 5 && window.LazyLoad === undefined) {
			return setTimeout(function () {
				lazyloadTimer++;
				buildLazyLoad();
			}, 500);
		}

		var lazyLoadInstance = new LazyLoad({
			// Your custom settings go here
		});
	}
	on(window, 'load', buildLazyLoad);
	/* ---------------------------------------- [END] LazyLoad */

	/* ---------------------------------------- [START] Fetch Svg Inline */
	function buildSvgFetchInline() {
		if (fetchSvgInline === undefined) {
			return false
		}

		const svgImgs = document.querySelectorAll('img.svg');
		[].forEach.call(svgImgs, (svg) => {
			fetchSvgInline(svg)
		});
	}
	on(window, 'load', buildSvgFetchInline);
	/* ---------------------------------------- [END] Fetch Svg Inline */

	/* ----------------------------------- [START]  */
	on(window, 'load', function () {
		// Start
	});
	/* ----------------------------------- [END]  */

	/* ---------------------------------------- [START] ScrollTriggerAni */
	// 有滑動到該區增加動態者增加class "data-aos" ， 滑動到該區增加class "is-animated"
	let aniSec = document.querySelectorAll('[data-aos]');
	const scrollTriggerAniThrottle = throttle(scrollTriggerAni, 200, 500); // 節流作用

	function scrollTriggerAni() {
		for (var i = 0; i < aniSec.length; i++) {
			if (isInViewport(aniSec[i])) {
				aniSec[i].classList.add('is-animated');
			}
		}

		cleanTrigger();

		/* If load all of the item, stop Listener */
		if (aniSec.length === 0) {
			window.addEventListener('scroll', scrollTriggerAniThrottle);
		}
	}

	function cleanTrigger() {
		aniSec = Array.prototype.filter.call(aniSec, function (ani) {
			return !ani.classList.contains('is-animated');
		});
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		const isVisible = el.offsetHeight !== 0;
		const offset = el.getAttribute('data-aos-offset') || '15%';
		const offsetValue = typeof offset === 'string' && offset.includes('%')
			? parseInt(offset) * 0.01 * (window.innerHeight || document.documentElement.clientHeight)
			: parseInt(offset);

		return (
			isVisible
			// && rect.bottom >= 0
			&& rect.right >= 0
			&& rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offsetValue
			&& rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
	/* ---------------------------------------- [END] ScrollTriggerAni */


	// ----------------------------
	const useMenuControl = () => {
		const header = document.querySelector('.header')
		if (!header) return

		const menuBtn = header.querySelector('.menu__btn')
		if (!menuBtn) return

		menuBtn.addEventListener('click', () => {
			header.classList.toggle('menu--opened')
		})
	}

	const useBackToTop = () => {
		const backToTopBtn = document.querySelector('.back-to-top-btn')
		if (!backToTopBtn) return

		backToTopBtn.addEventListener('click', () => {
			gsap.to(window, {
				duration: 1,
				ease: 'power4.inOut',
				scrollTo: {
					y: 0
				}
			})
		})
	}

	const useGradientBg = () => {
		if (!document.querySelector('#gradient-canvas')) return

		const gradient = new Gradient()
		gradient.initGradient('#gradient-canvas')
	}

	const useAccordion = () => {
		const accordions = [...document.querySelectorAll('.accordion')]
		if (!accordions.length) return

		accordions.forEach((accordion, index) => {
			const title = accordion.querySelector('.accordion-title')
			const content = accordion.querySelector('.accordion-content')
			if (!title || !content) return

			title.addEventListener('click', () => {
				accordions.forEach((accordion, i) => {
					if (i === index) {
						accordion.classList.toggle('is-active')
					} else {
						accordion.classList.remove('is-active')
					}
				})
			})
		})
	}

	const useModal = () => {
		const modals = [...document.querySelectorAll('.modal')]
		if (!modals.length) return

		const useOpenModal = (modal) => {
			modal.style.setProperty('display', 'block'),
			setTimeout(() => {
				modal.classList.add('is-active')
			}, 10)
		}

		const useCloseModal = (modal) => {
			const closeModal = () => {
				modal.style.setProperty('display', 'none')
				modal.removeEventListener('transitionend', closeModal)
			}

			modal.addEventListener('transitionend', closeModal)
			modal.classList.remove('is-active')
		}

		modals.forEach((modal) => {
			const modalId = modal.id
			if (!modalId) return

			const openers = [...document.querySelectorAll(`[data-modal-open="${modalId}"]`)]
			const closers = [...document.querySelectorAll(`[data-modal-close="${modalId}"]`), ...modal.querySelectorAll('[data-modal-close]')]

			openers.forEach((opener) => {
				opener.addEventListener('click', () => {
					useOpenModal(modal)
				})
			})

			closers.forEach((closer) => {
				closer.addEventListener('click', () => {
					useCloseModal(modal)
				})
			})
		})
	}

	// Document Ready
	document.addEventListener('DOMContentLoaded', () => {
		useMenuControl()
		useBackToTop()
		useGradientBg()
		useAccordion()
		useModal()
	})
})(window, document);
/* ---------------------------------------- [END] Document Ready */

